import React, { Component } from "react";
import "./index.css";
import { connect } from "react-redux";
import { goBack } from "redux-little-router";
import { Loader } from "semantic-ui-react";
import ProfileHead from "./components/ProfileHead";
import { hideUserSignInModal } from "../../actions";
import { isLoggedInUser, selectUserId, selectUser } from "../../util/selectors";
import { constructUserProfilePath } from "../../util/index";
import { watchProfileRequests } from "./sagas";
import { connectSaga } from "../../util/hoc/connectSaga";
import {
  loadOpenedProfileInfoByUserName,
  loadOpenedProfileInfoById,
  loadMoreOpenedProfilePosts,
  loadMoreOpenedProfileFollowers,
  loadMoreOpenedProfileFollowing,
  loadMoreOpenedProfileCollections,
  cleanOpenedProfile,
  cleanOpenedProfilePosts,
} from "./actions";
import UsersList from "../../components/UsersList";
import CollectionsPage from "../../scenes/CollectionsPage";
import { Fragment } from "redux-little-router";
import EmptyProfileHelmet from "./components/EmptyProfileHelmet";
import ProfileHelmet from "./components/ProfileHelmet";
import * as R from "ramda";
import UserPosts from "./components/UserPosts";

class OthersProfile extends Component {
  constructor(props) {
    super(props);
    this.loadOpenedProfileInfo = this.loadOpenedProfileInfo.bind(this);
    this.loadMoreOpenedProfilePosts = this.loadMoreOpenedProfilePosts.bind(this);
    this.loadMoreOpenedProfileFollowers = this.loadMoreOpenedProfileFollowers.bind(this);
    this.loadMoreOpenedProfileFollowing = this.loadMoreOpenedProfileFollowing.bind(this);
    this.loadMoreOpenedProfileCollections = this.loadMoreOpenedProfileCollections.bind(this);
  }
  componentDidMount() {
    this.loadOpenedProfileInfo(this.props);
  }

  componentWillUnmount() {
    this.props.cleanOpenedProfile();
    this.props.cleanOpenedProfilePosts();
  }

  componentWillUpdate(nextProps, nextState) {
    const { pathname, route } = this.props.currentRoute;
    const { pathname: nextPathname, route: nextRoute } = nextProps.currentRoute;
    if (pathname !== nextPathname) {
      if (
        route === nextRoute ||
        (this.getBaseRoute(this.props.currentRoute) === this.getBaseRoute(nextProps.currentRoute) &&
          !R.equals(this.getRouteIdentifier(this.props), this.getRouteIdentifier(nextProps)))
      ) {
        this.props.cleanOpenedProfile();
        this.props.cleanOpenedProfilePosts();
        this.loadOpenedProfileInfo(nextProps);
      }
    }
  }

  loadOpenedProfileInfo(props) {
    const { username, id } = this.getRouteIdentifier(props);
    if (username) {
      props.loadOpenedProfileInfoByUserName(username);
    } else {
      props.loadOpenedProfileInfoById(id);
    }
  }

  loadMoreOpenedProfilePosts(options) {
    const userId = this.props.userInfo._id;
    this.props.loadMoreOpenedProfilePosts({ userId, ...options });
  }
  loadMoreOpenedProfileFollowers(options) {
    const userId = this.props.userInfo._id;
    const pagingToken = this.props.userFollowers && this.props.userFollowers.pagingToken;
    this.props.loadMoreOpenedProfileFollowers({ userId, pagingToken, ...options });
  }
  loadMoreOpenedProfileFollowing(options) {
    const userId = this.props.userInfo._id;
    const pagingToken = this.props.userFollowing && this.props.userFollowing.pagingToken;
    this.props.loadMoreOpenedProfileFollowing({ userId, pagingToken, ...options });
  }
  loadMoreOpenedProfileCollections(options) {
    const userId = this.props.userInfo._id;
    const pagingToken = this.props.userCollections && this.props.userCollections.pagingToken;
    this.props.loadMoreOpenedProfileCollections({ userId, pagingToken });
  }
  //example : /profile/1 or /user/joe
  getBaseUrl(currentRoute) {
    const availableBaseRoutes = ["/profile/:id", "/user/:username"];
    return availableBaseRoutes.indexOf(currentRoute.route) === -1
      ? currentRoute.pathname
          .split("/")
          .slice(0, -1)
          .join("/")
      : currentRoute.pathname;
  }
  //example : /profile/:id or /user/:username
  getBaseRoute(currentRoute) {
    const availableBaseRoutes = ["/profile/:id", "/user/:username"];
    return availableBaseRoutes.indexOf(currentRoute.route) === -1
      ? currentRoute.route
          .split("/")
          .slice(0, -1)
          .join("/")
      : currentRoute.route;
  }
  getRouteIdentifier(props) {
    const { route, result: { parent: { route: parentRoute } = {} } = {} } = props.currentRoute;
    if (route === "/user/:username" || parentRoute === "/user/:username") {
      return { username: props.currentRoute.params.username };
    }
    const id = props.currentRoute.params.id || props.loggedInUserId;
    return { id };
  }
  // Check if current open profile is the logged in user's

  render() {
    const profilePath = constructUserProfilePath(this.props.userInfo);
    const user = this.props.userInfo;
    const posts = this.props.userPosts;
    const { userFollowers, userFollowing, userCollections, isSSRUser } = this.props;
    const baseUrl = this.getBaseUrl(this.props.currentRoute);

    if (!user) {
      return (
        <div className="padded">
          <EmptyProfileHelmet />
          <Loader size="large" active inline="centered" />
        </div>
      );
    }
    const isOwnProfile = this.props.loggedInUserId === this.props.userInfo._id;
    return (
      <div className="profile-wrapper">
        <ProfileHelmet user={user} profilePath={profilePath} />
        <ProfileHead user={user} baseUrl={baseUrl} isOwnProfile={isOwnProfile} />
        <Fragment forRoute="/collections">
          <CollectionsPage
            isOwnProfile={isOwnProfile}
            collections={userCollections}
            userId={this.props.userInfo._id}
            loadMoreCollections={this.loadMoreOpenedProfileCollections}
          />
        </Fragment>
        <Fragment forRoute="/followers">
          <UsersList
            users={userFollowers}
            isSSRUser={isSSRUser}
            loadMoreUsers={this.loadMoreOpenedProfileFollowers}
            userId={this.props.userInfo._id}
          />
        </Fragment>
        <Fragment forRoute="/following">
          <UsersList
            users={userFollowing}
            isSSRUser={isSSRUser}
            loadMoreUsers={this.loadMoreOpenedProfileFollowing}
            userId={this.props.userInfo._id}
          />
        </Fragment>
        <Fragment forRoute="/:id/followers">
          <UsersList
            users={userFollowers}
            isSSRUser={isSSRUser}
            loadMoreUsers={this.loadMoreOpenedProfileFollowers}
            userId={this.props.userInfo._id}
          />
        </Fragment>
        <Fragment forRoute="/:id/following">
          <UsersList
            users={userFollowing}
            isSSRUser={isSSRUser}
            loadMoreUsers={this.loadMoreOpenedProfileFollowing}
            userId={this.props.userInfo._id}
          />
        </Fragment>
        <Fragment forRoute="/">
          <UserPosts
            user={user}
            isSSRUser={isSSRUser}
            isOwnProfile={isOwnProfile}
            posts={posts}
            loadMorePosts={this.loadMoreOpenedProfilePosts}
          />
        </Fragment>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authorized: isLoggedInUser(state),
    loggedInUserId: selectUserId(state),
    userInfo: state.user.openedProfile.info,
    userFollowers: state.user.openedProfile.followers,
    userFollowing: state.user.openedProfile.following,
    userCollections: state.user.openedProfile.collections,
    userPosts: state.posts.openedProfileUserPosts,
    currentRoute: state.router,
    isSSRUser: state.user.isSSRUser,
    /* eslint-disable no-undefined */
    AuthorizationDone: selectUser(state) !== undefined,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    goBack: _ => dispatch(goBack()),
    hideUserSignInModal: () => dispatch(hideUserSignInModal()),
    loadOpenedProfileInfoById: userId => dispatch(loadOpenedProfileInfoById(userId)),
    loadOpenedProfileInfoByUserName: username => dispatch(loadOpenedProfileInfoByUserName(username)),
    loadMoreOpenedProfilePosts: (...props) => dispatch(loadMoreOpenedProfilePosts(...props)),
    loadMoreOpenedProfileFollowers: (...props) => dispatch(loadMoreOpenedProfileFollowers(...props)),
    loadMoreOpenedProfileFollowing: (...props) => dispatch(loadMoreOpenedProfileFollowing(...props)),
    loadMoreOpenedProfileCollections: (...props) => dispatch(loadMoreOpenedProfileCollections(...props)),
    cleanOpenedProfile: (...props) => dispatch(cleanOpenedProfile(...props)),
    cleanOpenedProfilePosts: (...props) => dispatch(cleanOpenedProfilePosts(...props)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(connectSaga(OthersProfile, watchProfileRequests));



// WEBPACK FOOTER //
// ./src/scenes/OthersProfile/index.js